import { getProductType, PRODUCT_TYPES } from '@/features/shared/utils/normalizeProduct'
import { formatPrice } from '@/features/shared/utils/formatter'

type ProductForProductDetails = {
  bogo: boolean
  couponId: string
  size: string
  price: number
  totalPrice: number
  original_price: number
  totalOriginalPrice: number
  totalSalePrice: number
  pricing?: { loyalty?: { price?: number | null } }
  cpgPromotion?: { category_id: number | undefined } | null
  descriptionLabels: string[]
  type: string
  hasCustomLabel: boolean
}
export const getProductDetails = (product: ProductForProductDetails) => {
  const {
    bogo,
    couponId,
    size,
    price,
    totalPrice,
    totalSalePrice,
    original_price,
    totalOriginalPrice,
    cpgPromotion,
    descriptionLabels = [],
  } = product
  const [descriptionLabel = ''] = descriptionLabels

  const productType = getProductType(product)
  const isByWeightProduct = productType === PRODUCT_TYPES.BY_WEIGHT
  const isCustomByWeightProduct = productType === PRODUCT_TYPES.CUSTOM_BY_WEIGHT

  const formattedSalePrice = formatPrice(totalSalePrice)
  const formattedPrice = isCustomByWeightProduct ? formatPrice(totalPrice) : formatPrice(price)
  const formattedOriginalPrice = isCustomByWeightProduct
    ? formatPrice(totalOriginalPrice)
    : formatPrice(original_price)

  let subtext = size
  if (isByWeightProduct) subtext = `per ${descriptionLabel}`
  if (isCustomByWeightProduct) subtext = `per ${descriptionLabel} (approx.)`

  const hasPromotion = Boolean(bogo || cpgPromotion?.category_id || couponId)

  return {
    subtext,
    productType,
    descriptionLabel,
    formattedPrice,
    formattedSalePrice,
    formattedOriginalPrice,
    isByWeightProduct,
    isCustomByWeightProduct,
    hasPromotion,
  }
}
